import { render, staticRenderFns } from "./RubiksCube.vue?vue&type=template&id=45eddb49&scoped=true&lang=pug"
import script from "./RubiksCube.vue?vue&type=script&lang=js"
export * from "./RubiksCube.vue?vue&type=script&lang=js"
import style0 from "./RubiksCube.vue?vue&type=style&index=0&id=45eddb49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eddb49",
  null
  
)

export default component.exports